<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-07-10 14:59:09
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-09-13 09:30:48
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/ESapply/component/invoiceDetail.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--  -->
<template>
  <div>
    <div class="tip-message">
      <span
        >产品质量评价发票分两部分开具：现场审查完成后，开具现场审查费的增值税发票；评价完成后，开具产品检测费的增值税发票。</span
      >
    </div>
    <div class="btn-wrap">
      <eui-btn type="weak" @click="showAddInvoiceDialog('add')"
        >添加发票信息</eui-btn
      >
    </div>
    <div class="address-list">
      <ul>
        <li
          v-for="(item, index) in invoiceList"
          :key="item.invoiceId"
          class="address-list-li"
          :class="[
            isCurrentInvoice == item.invoiceId ? 'is-active' : 'default',
          ]"
        >
          <template v-if="index <= showMoreIndex">
            <div class="address-info" @click="handleSelectInvoice(item, index)">
              <span
                :class="[
                  isCurrentInvoice == item.invoiceId ? 'is-active' : 'default',
                ]"
              ></span>
              <span>{{
                item.invoiceType === '101' ? '增值税普通发票' : '增值税专用发票'
              }}</span>
              <span>{{ item.title }}</span>
              <span>{{ item.identificationNumber }}</span>
            </div>
            <div class="handle-wrap">
              <eui-btn type="link" @click="showAddInvoiceDialog('edit', item)"
                >编辑</eui-btn
              >
              <eui-btn type="link" @click="handleDeleteInvoice(item.invoiceId)"
                >删除</eui-btn
              >
            </div>
          </template>
        </li>
      </ul>
    </div>
    <div class="show-more">
      <eui-btn type="link" @click="showMoreItem">{{
        showMoreIndex === invoiceList.length ? '收起发票' : '展开发票'
      }}</eui-btn>
    </div>
    <addInvoice
      :dialog-form-visible="addInvoiveDialogVisible"
      :invoice-title="invoiceTitle"
      :details="invoiceDetails"
      @submitPopupData="invoiceSubmitPopupData"
      @resetPopupData="invoiceResetPopupData"
    ></addInvoice>
    <eDialog
      dialog-title="提示"
      :center-dialog-visible="deleteInvoiceDialogFormVisible"
      :popup-width="'420px'"
      @resetPopupData="handleDeleteInvoiceResetPopupData"
      @submitPopupData="handleDeleteInvoiceSubmitPopupData"
    >
      <span>确定删除？</span>
    </eDialog>
  </div>
</template>

<script>
import addInvoice from './addInvoiceDialog.vue';
import api from '../../../../api/evaluation/index';
import eDialog from '../../../../../../components/common/e-dialog.vue';

export default {
  components: { addInvoice, eDialog },
  props: {
    invoiceList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isCurrentInvoice: {
      type: Number,
    },
  },
  data() {
    return {
      isActive: null,
      addInvoiveDialogVisible: false,
      showMoreIndex: 0,
      currentIndex: 0,
      invoiceTitle: '添加发票信息',
      deleteInvoiceDialogFormVisible: false,
      currentInvoiceId: null,
      invoiceDetails: {},
    };
  },

  computed: {},

  created() {},
  methods: {
    showAddInvoiceDialog(type, item) {
      if (type === 'add') {
        this.invoiceTitle = '添加发票信息';
      } else {
        this.invoiceTitle = '修改发票信息';
        this.invoiceDetails = item;
      }
      this.addInvoiveDialogVisible = true;
    },
    invoiceResetPopupData() {
      this.addInvoiveDialogVisible = false;
    },
    handleSelectInvoice(invoiceInfo, index) {
      this.currentIndex = index;
      this.$emit('handleSelectInvoice', invoiceInfo);
    },
    showMoreItem() {
      if (this.showMoreIndex === 0) {
        this.showMoreIndex = this.invoiceList.length;
      } else {
        this.$emit('handleInvoiceFold', this.currentIndex);
        this.showMoreIndex = 0;
      }
    },
    invoiceSubmitPopupData() {
      this.addInvoiveDialogVisible = false;
      this.$emit('updateInvoiceList');
    },
    // 删除发票
    async handleDeleteInvoice(invoiceId) {
      console.log(invoiceId);
      this.currentInvoiceId = invoiceId;
      this.deleteInvoiceDialogFormVisible = true;
    },
    // 取消删除发票
    handleDeleteInvoiceResetPopupData() {
      this.currentInvoiceId = null;
      this.deleteInvoiceDialogFormVisible = false;
    },
    // 确定删除发票

    async handleDeleteInvoiceSubmitPopupData() {
      const params = {
        invoiceIdList: [this.currentInvoiceId],
      };
      const res = await api.deleteInvoice(params);
      if (res.code === '200') {
        this.deleteInvoiceDialogFormVisible = false;
        this.$emit('updateInvoiceList');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';

.tip-message {
  padding: 15px 10px;
  background: #f4f7ff;
  font-size: 0;
  span {
    line-height: 1;
    color: #666;
    font-size: 14px;
  }
}
.btn-wrap {
  margin-top: 20px;
  margin-bottom: 10px;
}
.address-list {
  .address-list-li {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
    line-height: 40px;
    padding-left: 10px;
    padding-right: 10px;
    &.is-active {
      background: #f5f5f5;
    }
    .address-info {
      font-size: 0;
      line-height: 40px;
      display: flex;
      align-items: center;
      cursor: pointer;

      .default {
        display: inline-block;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 1px solid #d9d9d9;
      }
      .is-active {
        width: 18px;
        height: 18px;
        border: 6px solid $main-col;
        border-radius: 9px;
        display: inline-block;
      }
    }
    span {
      margin-right: 10px;
      color: #333;
      font-size: 14px;
      line-height: 1;
    }
  }
}
.show-more {
  font-size: 0;
  margin-top: 12px;
}
</style>
